function previous(indicators, current, slidesPerView) {
  const length = indicators * slidesPerView;
  return (current - slidesPerView + length) % length;
}

function next(indicators, current, slidesPerView) {
  const length = indicators * slidesPerView;
  return (current + slidesPerView) % length;
}

export const getNewIndex = ({
  direction,
  slides,
  slideIndex,
  showSlideCount,
  infinity
}) => {
  const increment = direction === 'next' ? 1 : -1;
  let newIndex = slideIndex + increment;
  const length = slides == null ? void 0 : slides.length;

  if (infinity) {
    newIndex = (newIndex + length) % length;
  }

  return showSlideCount ? Math.min(Math.max(newIndex, 0), length - 1) : newIndex;
};
export const getSiblings = ({
  lazy = false,
  length = 0,
  slidesPerView = 1,
  active = 0
} = {}) => {
  const items = Array.from(Array(length).keys());
  if (!lazy) return items;
  const pages = Math.ceil(length / slidesPerView);
  const lastPageLength = length % slidesPerView || slidesPerView;
  const currentPage = Math.ceil((active + 1) / slidesPerView);
  let nextPage = currentPage + 1;
  if (nextPage > pages) nextPage = 1;
  let prevPage = currentPage - 1;
  if (prevPage < 1) prevPage = pages;

  const getPages = page => {
    const start = page * slidesPerView - slidesPerView;
    const end = page === pages ? start + lastPageLength : start + slidesPerView;
    return items.slice(start, end);
  };

  return [...getPages(prevPage), ...getPages(currentPage), ...getPages(nextPage)].sort();
};
export function carouselReducer(state, action) {
  switch (action.type) {
    case 'jump':
      return Object.assign({}, state, {
        desired: action.desired * action.slidesPerView
      });

    case 'next':
      return Object.assign({}, state, {
        desired: next(action.indicators, state.active, action.slidesPerView)
      });

    case 'prev':
      return Object.assign({}, state, {
        desired: previous(action.indicators, state.active, action.slidesPerView)
      });

    case 'done':
      return Object.assign({}, state, {
        offset: NaN,
        active: state.desired,
        visible: action.lazy ? Array.from(new Set([...state.visible, ...getSiblings(Object.assign({}, action, {
          active: state.desired
        }))])) : state.visible
      });

    case 'drag':
      return Object.assign({}, state, {
        offset: action.offset
      });

    default:
      return state;
  }
}